import React, { useState, useEffect } from "react";
import { API } from 'aws-amplify';
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";

function ProductDisplay(props) {
  const { user: { attributes: { email, sub } = {} } = {} } = props;
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState(props.message)
  const [orderComplete, setOrderComplete] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (props.message && props.message.text) {
      setOrderComplete(props.message.type === 'success')
      if (props.message.type !== 'success') {
        setMessage(props.message.text)
      }
    }
  }, [props.message])

  useEffect(() => {
    if (message) {
      setOpen(true)
    }
  }, [message])

  const handleDismiss = () => {
    setOpen(false)
    setMessage(undefined)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      setLoading(true)
      const result = await API.post('stripeAPI', `/checkout?email=${email}`)
      const { session } = result
      if (session && session.url) {
        window.location.replace(session.url)
      }
      setLoading(false)
    } catch (error) {
      setMessage('An error occurred, please reload the page.')
    }
  }

  const handleStartFreeTrial = async (event) => {
    try {
      setLoading(true)
      await API.put('appApi', `/user/${sub}/free-trial`)
      setMessage('Success!')
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    } catch (error) {
      setMessage('An error occurred, please reload the page.')
    }
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
      <Snackbar open={open} onClose={handleDismiss} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleDismiss} severity="info">{message}</Alert>
      </Snackbar>
      <Card sx={{ maxWidth: '650px', p: 3 }}>
        {!orderComplete && (
          <div>
            <section>
              <div className="product">
                <div className="description">
                  <Typography variant="h4">Country swing dance masterclass</Typography>
                  <Typography variant="h6" >Ready to unlock the power, romance and intimacy you've always wanted?</Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                    <Box sx={{ maxWidth: '600px', width: '100%' }} component='img' src="https://s3.us-west-1.amazonaws.com/media.giddyup.dance/m_setyoursails.gif" alt="Giddyup swing move" className="banner" loading="lazy" />
                  </Box>
                  <hr />
                  <Box sx={{ mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Giddyup country swing masterclass</Typography>
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography >$49.00</Typography>
                    </Box>
                  </Box>
                </div>
              </div>
              <form onSubmit={handleSubmit} action="/checkout" method="POST">
                <Box sx={{ textAlign: 'right' }}>
                  <Button color="secondary" variant="contained" type="submit" disabled={loading || orderComplete}>
                    Checkout
                  </Button>
                </Box>
              </form>
            </section>
            {
              document.URL.includes('/free-trial') && (
                <section>
                  <Box component="hr" sx={{ mt: 3 }} />
                  <Typography variant="h6" >Thanks for being a beta tester! Start your 30 day free trial.</Typography>
                  <Box sx={{ textAlign: 'right' }}>
                    <Button onClick={handleStartFreeTrial} size="small" color="primary" variant="outlined" type="submit" disabled={loading || orderComplete}>
                      Start free trial
                    </Button>
                  </Box>
                </section>
              )
            }
          </div>
        )}
        {orderComplete && (
          <div className="confirmation">
            <Typography variant="h4">Yeehaw!</Typography>
            <Typography variant="h6" >Thanks for your purchase! Welcome to the Giddyup Dance family. You will receive an email confirmation shortly. Sent to {email}</Typography>
          </div>
        )}
      </Card>
    </Box>
  )
};

export default function CheckoutPage(props) {
  const [message, setMessage] = useState();

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage({
        type: 'success',
        text: "Order placed! You will receive an email confirmation."
      }
      );
    }

    if (query.get("canceled")) {
      setMessage({
        type: 'canceled',
        text: "Order canceled -- checkout when you're ready."
      });
    }
  }, []);

  return (
    <ProductDisplay message={message} user={props.user} />
  );
}